import React, { useState } from 'react'
import { IconButton, Typography, Modal, Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Accordion, AccordionSummary, AccordionDetails, Paper } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "40%",
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: 24,
  borderRadius: "15px",
  p: 0,
};

// STYLED DESIGN FOR TABLE CELL TO SEE COLORFULL
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#FFF4F4",
    color: "black",
    padding: '12px 16px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: '14px',
    padding: '12px 16px',
  },
}));

// STYLED DESIGN FOR TABLE ROW TO SEE COLORFULL
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#FFFFFF",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#F4F7FC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const PackageInclusionModel = ({showInclusion,handleCloseInclusion,data}) => {
  // const [expanded, setExpanded] = useState(false);

  // const handleAccordionChange = (panel) => (event, isExpanded) => {
  //   setExpanded(isExpanded ? panel : false);
  // };

// const data =[
//   {
//       "ItemType": "Package",
//       "itemid": "881",
//       "TestName": "IRON STUDIES (IRON + TIBC)",
//       "SampleRemarks": "2 mL SERUM IN GEL TUBE",
//       "SampleTypeName": "SERUM",
//       "FromAge": "0",
//       "ToAge": "70000",
//       "Gender": "B",
//       "Requiredfields": "",
//       "TestParameters": [
//           "IRON",
//           "TOTAL IRON BINDING CAPACITY (TIBC)",
//           "LIQUID BIOPSY EGFR TRUE",
//           "TRANSFERRIN",
//           "% OF SATURATION"
//       ],
//       "RequiredAttachment": "",
//       "PackageID": "1441",
//       "TestParametersObj": [
//           {
//               "ParameterID": "120",
//               "ParameterName": "IRON",
//               "ResultRequired": "1",
//               "DuplicateAllowed": "0",
//               "IsHeader": "No",
//               "PrintOrder": "1",
//               "ISBold": "0",
//               "ISCommentField": "0"
//           },
//           {
//               "ParameterID": "86",
//               "ParameterName": "TOTAL IRON BINDING CAPACITY (TIBC)",
//               "ResultRequired": "1",
//               "DuplicateAllowed": "0",
//               "IsHeader": "No",
//               "PrintOrder": "2",
//               "ISBold": "0",
//               "ISCommentField": "0"
//           },
//           {
//               "ParameterID": "2036",
//               "ParameterName": "LIQUID BIOPSY EGFR TRUE",
//               "ResultRequired": "1",
//               "DuplicateAllowed": "0",
//               "IsHeader": "No",
//               "PrintOrder": "3",
//               "ISBold": "0",
//               "ISCommentField": "0"
//           },
//           {
//               "ParameterID": "310",
//               "ParameterName": "TRANSFERRIN",
//               "ResultRequired": "1",
//               "DuplicateAllowed": "0",
//               "IsHeader": "No",
//               "PrintOrder": "4",
//               "ISBold": "0",
//               "ISCommentField": "0"
//           },
//           {
//               "ParameterID": "1264",
//               "ParameterName": "% OF SATURATION",
//               "ResultRequired": "1",
//               "DuplicateAllowed": "0",
//               "IsHeader": "No",
//               "PrintOrder": "5",
//               "ISBold": "0",
//               "ISCommentField": "0"
//           }
//       ]
//   },
//   {
//       "ItemType": "Package",
//       "itemid": "232",
//       "TestName": "FERRITIN",
//       "SampleRemarks": "3ML SERUM IN GEL TUBE",
//       "SampleTypeName": "SERUM",
//       "FromAge": "0",
//       "ToAge": "70000",
//       "Gender": "B",
//       "Requiredfields": "",
//       "TestParameters": [
//           "FERRITIN"
//       ],
//       "RequiredAttachment": "",
//       "PackageID": "1441",
//       "TestParametersObj": [
//           {
//               "ParameterID": "232",
//               "ParameterName": "FERRITIN",
//               "ResultRequired": "1",
//               "DuplicateAllowed": "0",
//               "IsHeader": "No",
//               "PrintOrder": "1",
//               "ISBold": "0",
//               "ISCommentField": "0"
//           }
//       ]
//   }
// ]
  return (
    <Modal open={showInclusion}>
    <Box sx={style}>
      {/* Modal Header */}
      <Box sx={{
        position: 'sticky',
        top: 0,
        bgcolor: 'background.paper',
        zIndex: 2,
        borderTopLeftRadius: "30px",
        borderTopRightRadius: "30px",
        borderBottom: '2px solid #e0e0e0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
      }}>
        <Box sx={{ p: 2 }}>
          <Typography 
            variant="h6" 
            component="h2" 
            sx={{ 
              display: "flex", 
              justifyContent: "space-between",
              alignItems: "center",
              fontWeight: 600,
              color: '#1976d2',
            }}
          >
             {/* Package Inclusions */}
             Inclusions
            <IconButton 
              onClick={() => handleCloseInclusion()} 
              color="error"
              sx={{ 
                '&:hover': { 
                  backgroundColor: 'rgba(211, 47, 47, 0.04)' 
                } 
              }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
        </Box>
      </Box>

      {/* Table Content */}
      <Box sx={{ 
        overflowY: 'auto',
        maxHeight: 'calc(90vh - 73px)',
        p: 2 
      }}>
        <TableContainer component={Paper} sx={{ boxShadow: 'none', backgroundColor: '#F4F7FC' }}>
          <Table stickyHeader >
            <TableHead>
              <StyledTableRow>
                <StyledTableCell sx={{fontWeight: 600,textTransform: 'uppercase'}}>Test Name</StyledTableCell>
                {/* <StyledTableCell sx={{fontWeight: 600,textTransform: 'uppercase'}}>Item Type</StyledTableCell>
                <StyledTableCell sx={{fontWeight: 600,textTransform: 'uppercase'}}>Sample Type</StyledTableCell>
                <StyledTableCell sx={{fontWeight: 600,textTransform: 'uppercase'}}>Sample Remarks</StyledTableCell>
                <StyledTableCell sx={{fontWeight: 600,textTransform: 'uppercase'}}>Gender</StyledTableCell>
                <StyledTableCell sx={{fontWeight: 600,textTransform: 'uppercase'}}>Age Range</StyledTableCell>
                <StyledTableCell sx={{fontWeight: 600,textTransform: 'uppercase'}}>Parameters</StyledTableCell> */}
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {data.map((item) => (
                <StyledTableRow key={item.itemid}>
                  <StyledTableCell>{item.TestName}</StyledTableCell>
                  {/* <StyledTableCell>{item.ItemType}</StyledTableCell>
                  <StyledTableCell>{item.SampleTypeName}</StyledTableCell>
                  <StyledTableCell>{item.SampleRemarks}</StyledTableCell>
                  <StyledTableCell>{item.Gender === 'B' ? item?.Gender : item?.Gender}</StyledTableCell>
                  <StyledTableCell>{`${item.FromAge} - ${item.ToAge}`}</StyledTableCell>
                  <StyledTableCell>
                    <Accordion 
                      expanded={expanded === `panel${item.itemid}`}
                      onChange={handleAccordionChange(`panel${item.itemid}`)}
                      sx={{
                        '&:before': {
                          display: 'none',
                        },
                        boxShadow: 'none',
                        backgroundColor: 'transparent'
                      }}
                    >
                      <AccordionSummary 
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                          backgroundColor: '#f5f5f5',
                          borderRadius: 1,
                          '&:hover': {
                            backgroundColor: '#eeeeee'
                          }
                        }}
                      >
                        <Typography>View Parameters ({item.TestParameters.length})</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Table size="small">
                          <TableHead>
                            <StyledTableRow>
                              <StyledTableCell sx={{ 
                                fontWeight: 600, 
                                textTransform: 'uppercase'
                              }}>
                                Parameter Name
                              </StyledTableCell>
                              <StyledTableCell sx={{ 
                                fontWeight: 600, 
                                textTransform: 'uppercase'
                              }}>
                                Parameter ID
                              </StyledTableCell>
                              <StyledTableCell sx={{ 
                                fontWeight: 600, 
                                textTransform: 'uppercase'
                              }}>
                                Print Order
                              </StyledTableCell>
                            </StyledTableRow>
                          </TableHead>
                          <TableBody>
                            {item.TestParametersObj.map((param) => (
                              <StyledTableRow key={param.ParameterID}>
                                <StyledTableCell>{param.ParameterName}</StyledTableCell>
                                <StyledTableCell>{param.ParameterID}</StyledTableCell>
                                <StyledTableCell>{param.PrintOrder}</StyledTableCell>
                              </StyledTableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </AccordionDetails>
                    </Accordion>
                  </StyledTableCell> */}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  </Modal>
  )
}

export default PackageInclusionModel